export default {"src":"/_next/static/media/online-safe.13595857.svg","height":34,"width":148};